<template>
    <div class="page"
         @click="dataCompleteFun()"
         style="height:100vh;overflow-y: scroll;overflow-x: hidden"
         :id="scrollId">
        <div class="page-content">
            <div class="img-div">
                <img class="rand_pic" src="@/assets/extension/img1.jpg" alt="My CEO Stepbrother Kissed me">
            </div>
            <div id="copycontent" class="type8">
                <section class="content" >
                    <p class="innerTitle"><span>My CEO Stepbrother Kissed me </span></p>
                    <section
                            class="boxbr">
                        <p>At the reception desk of the Romantic Hotel.</p>
                        <p>Jeffery Sterling took the room card and said to the young girl at his side, "Follow me."</p>
                        <p>Melinda held one strap of her shoulder bag, lowering her head, dumbly following him up to the room like a little quail.</p>
                        <p>As soon as the door was closed, she was kissed by the man who was holding her against the wall. </p>
                        <p>His breath mixing with the faint smell of tobacco, full of the sense of masculinity, charmed her very much.</p>
                        <p>Melinda felt dizzy, she was pushed into the bed by the man...</p>
                        <p>The young girl was shaking all over. Her timid look charmed the man and made him want to tease her.</p>
                        <p>The fact was, they just met today.</p>
                        <p>He was the son of her mom's new boyfriend.</p>
                        <p>Two hours ago, the two families officially met for the first time.</p>
                        <p>During the meal, her fork was accidentally dropped on his lap.</p>
                        <p>When she bent down to pick them up, her nose accidentally rubbed at his belt buckle and he stared at her for half a minute.</p>
                        <p>Once the meal was over, the two tacitly agreed to dump their parents and meet downstairs.</p>
                        <p>...</p>
                        <p>Melinda finished her shower and got out of the bathroom. </p>
                        <p>"You're bad, you broke my dress."</p>
                        <p>Jeffery's low voice was lazy and sexy, "I'll buy you a new one."</p>
                        <p>"That's not BUY for me, it's compensate me." Melinda used her soft voice to correct the man. </p>
                        <p>She put on the dress and put on the man's coat to cover up the unzipped zipper.</p>
                        <p>Jeffery extinguished his cigarette and put on his clothes. And then he saw that Melinda's eyes were glued to him. </p>
                        <p>He raised his eyebrows. The girl said in a sweet and soft voice "My dress."</p>
                        <p>It was only one dress. Did she think of him as a lair?</p>
                        <p>Jeffery took his phone and put it into his pants pocket, and he leisurely took the girl to a nearby mall for shopping.</p>
                        <p>The mall belonged to the Sterling Family.</p>
                        <p>The manager of the women's clothing counter personally entertained them. She asked the girl what type of cloths did she want.</p>
                        <p>Melinda did not answer the manager, but she looked back at Jeffery Sterling and asked, "Whatever I want?"</p>
                        <p>The man sat on the sofa and folded his long legs in sofa casual pose. "If you like them all, you can have them all."</p>
                        <p>"Well, then I like them all."</p>
                        <p>The young girl's soft words made everyone dumbfounded, and there was also a blink of shock flashed across Jeffery's deep eyes.</p>
                        <p>Being stared at by her clear deer-like eyes, Jeffery Sterling's thin lips lightly hooked, "Manager, what are you waiting for, all the clothes in the store, wrap them up for her."</p>
                        <p>The counter manager reacted to the shock and said, "Yes, of course, Mr. Sterling. And which address should I deliver these clothes to you? "</p>
                        <p>Melinda told the address and her contact information to the counter manager.</p>
                        <p>The manager took note of her address, announced the whole store was closed, and started packing clothes for Melinda.</p>
                        <p>Melinda picked a lotus pink dress and was about to put it on, but Jeffery took a red halter dress to her instead, and let her take this one.</p>
                        <p>Melinda was not used to the dress and wanted to change to another one. But he stopped her, "I like this one."</p>
                        <p>He gave Melinda a gesture to follow up. And then he hooked her shoulders and took her to the fitting room...</p>
                        <p>When the two of them came out from the fitting room, it was already an hour later.</p>
                        <p>Melinda followed the handsome man to get out with a blushing face. She was abashed like a quail.</p>
                        <p>Jeffery took Melinda out of the mall.</p>
                        <p>------</p>
                        <p>No one asked about her identity, and Jeffery didn't introduce her to anyone.</p>
                        <p>After the party, he took her back to his residence downtown instead of their family mansion.</p>
                        <p>At 10:30 p.m., her mom transferred five hundred dollars to her and wished her a happy birthday. </p>
                        <p>Melinda texted back to her mom to thank her while she was lying in the bed. Her face was still red, which was a hint that the thing she and Jeffery had done. She checked her online bank account.</p>
                        <p>Four-figure sums.</p>
                        <p>Rosie called this class upgrading. Now she had more than five thousand.</p>
                        <p>"What are you laughing at?"</p>
                        <p>Melinda raised her head and she met into Jeffery's deep eyes. She pursed her lips and showed him the transfer message.  </p>
                        <p>"Mom had transferred me some money to wish me a happy birthday."</p>
                        <p>Jeffery said casually, "Do you want me to transfer some money to you too?"</p>
                        <p>Melinda thought about it, "if you want to."</p>
                        <p>After adding friends, the man transferred eight thousand to her.</p>
                        <p>Melinda was very happy with over ten-thousand income in one day,
                            She had never had so much money before.</p>
                        <p>Jeffery gave her so much money, he must like her a lot.</p>
                        <p>Melinda sat up and wrapped her arms around his neck and kissed him on the cheek, blushing shyly, "I like you too."</p>
                        <p>Like him too?</p>
                        <p>Jeffery's deep eyes narrowed obscurely. His long fingers pinching her chin with a cigarette in his other fingers snorted lightly and murmured, "You're a little fool."</p>
                        <p>Melinda did not hear him. The man looked not very happy, but she did not know what she had said wrong. So she looked at him a little lost.</p>
                        <p>Her face, which was very tender and pretty, looked helpless to him and made his heart melted.</p>
                        <p>"I'm complimenting you."</p>
                        <p>Jeffery Sterling snuffed out the smoke. He took the girl into his arms to let her sleep.</p>
                        <p>The girl pillowed his shoulder, but she did not behave. She moved around and looked at him several times.</p>
                        <p>Jeffery was not pleased, so he asked her in a deep voice, "What do you want?"</p>
                        <p>He thought that she was quite troublesome.</p>
                        <p>"You haven't said happy birthday to me."</p>
                        <p>Melinda stopped her words and looked at Jeffery. He could feel her breath in his chest. And he could see her dark eyes looking at him with expectation.</p>
                        <p>He closed his eyes for a while, and said in a low voice, "Happy birthday."</p>
                        <p>He patted her buttocks slightly to let her honestly sleep.</p>
                        <p>Finally hearing what she wanted to hear, Melinda Green was satisfied. She thanked Jeffery in a soft tone and went to sleep in his arms.</p>
                        <p>------</p>
                        <p>Now, she had upgraded her class.</p>
                        <p>She got such a large sum of money by selling those clothes, Melinda sent a message to Jeffery Sterling, asking if he was free.</p>
                        <p>She wanted to buy him dinner so that she could feel at ease.</p>
                        <p>Jeffery might be too busy. Melinda didn't get a reply from him for thirty minutes. She was a bit disappointed. At this time, a classmate asked her, "Melinda, we are going to sing at a club. Do you want to come?"</p>
                        <p>Melinda Green shook her head and said that she didn't want to go.</p>
                        <p>Edison York, from the philosophy department, was going to host a party at Fog City Club. He would pay the bill for every schoolmate. The only condition was that he want Melinda Green to come to the party.</p>
                        <p>At Fog City, the minimum consumption of night club was at least five figures to start. A few young students wanted to take this opportunity to go. So they tried their best to persuade Melinda.</p>
                        <p>A young man with yellow hair grabbed Melinda's backpack, and two girls took her out of the classroom.</p>
                        <p>Melinda was stuffed into the copilot of the sports car, she was so angry that her eyes went red. </p>
                        <p>"I won't go, stop your car and let me go. Or I have to tell the teacher that you bully me."</p>
                        <p>Edison, who was driving the car, was annoyed, "You call this bullying? Melinda Green, if you dare to say any bullshit one more time, I will let you know what is real bullying."</p>
                        <p>There were seven people, three girls, and four boys. So they asked for a large private room.</p>
                        <p>It might be because they don't want Melinda to leave early. So they crowded her in the center and kept her drinking. But Melinda had never drunk alcohol before, so she wouldn't drink anyway. She kept saying that she wanted to go home, which made everybody on the scene unpleased</p>
                        <p>Edison put half a bottle of red wine in front of her and said, "Drink it all and I will let you go. </p>
                        <p>Otherwise, tonight, you won't go anywhere except my bedroom."</p>
                        <p>"I, I don't drink."</p>
                        <p>"If you don't drink, you should sit tight. If your dare to cry or to go, I'll rape you here. Believe me or not." Edison York's threat scared her.</p>
                        <p>Melinda Green clutched her bag and bit her lower lip for a while, "If I take your drink, will you let me go?"</p>
                        <p>"I'm a man of my word." Edison York snorted coldly.</p>
                        <p>Melinda hated these people and didn't want to stay any longer.</p>
                        <p>She had no choice but to drink. So she took the bottle and drink up the wine.</p>
                        <p>The red liquid winding along her chin made her fairy neck more beautiful and sexy. Her look impressed all the boys present. They all felt their desire.</p>
                        <p>Seeing Melinda's charming manner, Edison was a bit lost. He licked his lips and wanted to talk. At this time, Melinda finished all her drinks and put the bottle on the table, with her face blushing, "I did my word. You should keep yours."</p>
                        <p>Melinda took a deep breath and made the threat. After finishing her words, she held her bag and rushed to run.</p>
                        <p>Just when she got out of the room, her wrist was pulled by Edison who chased after her, "Mindy, let me give you a ride."</p>
                        <p>"No, don't touch me."</p>
                        <p>Melinda Green tried to shake off his hand, but she was dragged into his arms. While she could not get off Edison, she saw a man walking in her direction. She felt hope and shout to him, "Help! Let go of me! Help! Jeff! Jeff! Help me!"</p>
                    </section>
                </section>
            </div>
        </div>
        <div class="center">
            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('andriod')" href="javascript:void(0);"><img src="../../assets/account/btn_android.png"/></a>
            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('ios')" href="javascript:void(0);"><img src="../../assets/account/btn_iphone.png"/></a>
        </div>
    </div>
</template>

<script>
    import "utils/lib/rem";
    import Clipboard from 'clipboard'
    /*Facebook Pixel Code*/
    // !function(f,b,e,v,n,t,s)
    // {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    //     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    //     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    //     n.queue=[];t=b.createElement(e);t.async=!0;
    //     t.src=v;s=b.getElementsByTagName(e)[0];
    //     s.parentNode.insertBefore(t,s)}(window, document,'script',
    //     'https://connect.facebook.net/en_US/fbevents.js');
    // fbq('init', '604117387548801');
    // fbq('track', 'PageView');
    import { extensionDetail } from "apiurl/extension";
    export default {
        name: "",
        data () {
            return {
                copyCon: '24',
                bookName: '马甲',
                scrollTimer: null, // 滚动定时器
                pauseTimer: null, // 暂停定时器
                scrollId: 'scrollId', // 滚动容器id
                scrollDirection: 'down' // 滚动方向 up向上 down向下
            }
        },
        mounted () {
            if (this.$route.query.num) {
                this.copyCon = this.$route.query.num
                this.bookName = this.$route.query.name
            }
            // 去除点击监听
            window.document.removeEventListener('click', this.pauseScroll)
            // 重设点击监听
            window.document.addEventListener('click', this.pauseScroll, false)
            // this.getDetail(this.bookName, 'load')
        },
        methods: {
            async getDetail (name, action) {
                let res = await extensionDetail(name, action);
            },
            copy () {
                var clipboard = new Clipboard('.download-btn')
                clipboard.on('success', e => {
                    console.log('复制成功')
                    //  释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e =>{
                    // 不支持复制
                    console.log('该浏览器不支持复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            downlowFun (flag) {
                // this.copy()
                // fbq('track', 'Purchase', {currency: "USD", value: 1.00});
                if (flag == 'andriod') {
                    // this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://play.google.com/store/apps/details?id=com.blackstone.reader'
                } else {
                    // this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://apps.apple.com/us/app/meetnovel/id1628470640'
                }
            },
            // 数据加载完成方法
            dataCompleteFun() {
                // 开启滚动
                this.autoScroll()
            },
            autoScroll() {
                const scrollHeight = document.getElementById(this.scrollId).scrollHeight
                const clientHeight = document.getElementById(this.scrollId).clientHeight
                const scroll = scrollHeight - clientHeight
                // 滚动长度为0
                if (scroll === 0) {
                    return
                }
                // 触发滚动方法
                this.scrollFun()
            },
            pauseScroll() {
                // 定时器不为空
                if (this.scrollTimer) {
                    // 清除定时器
                    clearInterval(this.scrollTimer)
                    this.scrollTimer = null
                    // 一秒钟后重新开始定时器
                    this.pauseTimer = setTimeout(() => {
                        this.scrollFun()
                    }, 0)
                }
            },
            scrollFun() {
                // 如果定时器存在
                if (this.scrollTimer) {
                    // 则先清除
                    clearInterval(this.scrollTimer)
                    this.scrollTimer = null
                }
                this.scrollTimer = setInterval(() => {
                    const scrollHeight = document.getElementById(this.scrollId).scrollHeight
                    const clientHeight = document.getElementById(this.scrollId).clientHeight
                    const scroll = scrollHeight - clientHeight
                    // 获取当前滚动条距离顶部高度
                    const scrollTop = document.getElementById(this.scrollId).scrollTop
                    // 向下滚动
                    if (this.scrollDirection === 'down') {
                        const temp = scrollTop + 10
                        document.getElementById(this.scrollId).scrollTop = temp // 滚动
                        // 距离顶部高度  大于等于 滚动长度
                        if (scroll <= temp) {
                            // 滚动到底部 停止定时器
                            clearInterval(this.scrollTimer)
                            this.scrollTimer = null
                            // 改变方向
                            this.scrollDirection = 'down'
                            // 一秒后重开定时器
                            setTimeout(() => {
                                this.scrollFun()
                            }, 1000)
                        }
                    }
                }, 250)
            }
        },
        destroyed() {
            // 清理定时器
            clearTimeout(this.pauseTimer)
            this.pauseTimer = null
            clearInterval(this.scrollTimer)
            this.scrollTimer = null
            // 清理点击监听
            window.document.removeEventListener('click', this.pauseScroll)
        },
    }
</script>
<!--<noscript><img height="1" width="1" style="display:none"-->
<!--               src="https://www.facebook.com/tr?id=604117387548801&ev=PageView&noscript=1"-->
<!--/></noscript>-->
<!-- End Facebook Pixel Code -->
<style scoped lang="scss">
    @import "../../styles/type8";
    *{
        -moz-user-select:none;
        -webkit-user-select:none;
        user-select:none;
    }
    .page{
        display: inline-block;
        width: 100%;
        height: auto;
        background: #fff;
    }
    .page-content{

        margin:auto;
        /*padding: 1.25rem;*/
        p{
            line-height: 1.6;
            margin-bottom: 20px;
            margin: 0 0 10px;
        }
    }
    .rand_pic{
        width: 100%;
        height: 20.75rem;
    }
    .downloadCon{
        width: 100%;
        text-align: center;
        color: #1f80e3;
        font-size:1.25rem;
        font-weight: bold;
        .name{
            color: #fe3f72;
            font-size: 1.7rem;
        }
        .num{
            color:  #e31f44;
            font-size: 1.65rem;
        }
    }
    .clickImage{
        margin-top: -10px;
        text-align: center;
        img{
            max-width: 100%;
        }
    }
    .center{
        display: inline-block;
        width: 100%;
        margin: auto;
        margin-bottom: 20px;
        .download-btn {
            display: block;
            width: 50%;
            float: left;
            text-align: right;
            img{
                width: 10.75rem;
                height: 3.5rem;
            }
        }
        .download-btn:last-child{
            text-align: left;
            img{
                margin-left: 1.25rem;
            }
        }
    }
</style>
